import React from "react";
import { ListGroup } from "react-bootstrap";
import { useSelector } from "react-redux";
import Message from "./Message";
import Skeleton from "react-loading-skeleton";
import PatientListItem from "./PatientListItem";

const PatientList = ({ clinicId, reqDate }) => {
  const patientListStore = useSelector((state) => state.patientListStore);
  const { loading, patients, error } = patientListStore;

  return (
    <div className="my-3">
      {error && (
        <Message
          children={`Patient List Store Err: ${error}`}
          variant={`danger`}
        />
      )}
      {loading && (
        <>
          <Skeleton height="100px" className="mb-5" count={6} />
        </>
      )}{" "}
      {patients?.length === 0 ? (
        <Message children={"No patient found"} variant={`info`} />
      ) : (
        <>
          {patients?.map((p, order = 0) => (
            <ListGroup key={order + 1}>
              <PatientListItem
                patient={p}
                clinicId={clinicId}
                reqDate={reqDate}
              />
            </ListGroup>
          ))}
        </>
      )}
    </div>
  );
};

export default PatientList;
